import { render } from "./RocketSkin.vue?vue&type=template&id=5f1be075&scoped=true&ts=true"
import script from "./RocketSkin.vue?vue&type=script&lang=ts"
export * from "./RocketSkin.vue?vue&type=script&lang=ts"

import "./RocketSkin.vue?vue&type=style&index=0&id=5f1be075&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1be075"]])

export default __exports__